export enum PanelClientsAddCorporateStepsEnum {
    Company = 1,
    DocumentDetails,
    Addresses,
    UploadDocuments,
}
